import classNames from "classnames";
import React from "react";

interface Props {
  className?: string;
}

export const ArrowIcon: React.FC<Props> = ({ className }) => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames("stroke-current", className)}
    >
      <path
        d="M1.96875 16.8492L8.96549 9.8525M1.96875 16.8492L8.9655 23.846M1.96875 16.8492L32.5 16.8493"
        strokeWidth="2"
      />
    </svg>
  );
};
